import { SelectOption } from '@iddataweb/idw-common-ui/types';
import countryRegionData, { Country } from 'country-region-data';

export const NATIONALITY_LIST: Array<Country> = countryRegionData;

export const NATIONALITY_SELECT_OPTIONS: Array<SelectOption> = countryRegionData.map(country => (
    { value: country.countryShortCode, label: `${country.countryName} (${country.countryShortCode})` }
));